import styled from "styled-components";
import { palette, font } from "styled-theme";
import { LabelTypography } from "@components/select/select.styles";

export const Money = styled.div`
  display: inline-block;
  font-size: 20px;
  font-weight: ${font("headingWeight")};
  color: ${palette('loanLimit',0)};
  padding-top: 8px;
`;

export const LoanLimitProductType = styled.span`
  text-transform: ${font("headingCase")};
  font-weight: ${font("headingWeight")};
  color: ${palette('loanLimit',0)};
`;

export const SelectLabelTypographyDiv = styled(LabelTypography).attrs({as: "div"})`
  padding-top: 10px;
`;

const Wrapper = styled.div`
  padding-bottom: 18px;

`;

export default Wrapper;